module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"expand_review":"查看更多","collapse_review":"顯示較少"}}')
  delete Component.options._Ctor
}
